import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export function Input({ error, className = '', ...rest }: InputProps) {
  return (
    <div className="flex flex-col gap-1">
      <input
        {...rest}
        className={[
          'w-full px-3 py-2 rounded-lg border text-text-dark placeholder-text-light bg-white transition-colors duration-150',
          'focus:outline-none focus:ring-2 focus:ring-chocolate/20 focus:border-chocolate',
          error ? 'border-danger' : 'border-champagne-dark',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      />
      {error && <span className="text-danger text-sm">{error}</span>}
    </div>
  );
}
